import Api from "./Api";
import { get, post, put } from "./axiosRequest";

export async function login(username, password) {
    return await post(Api.LOGIN, null, {
        username,
        password
    })
}
export async function fetchUser() {
    return await get(Api.FETCH_USER)
}

export async function loadUserInfo() {
    return await get(Api.LOAD_USER_INFO)
}
export async function changePassword(password, newPassword) {
    return await put(Api.CHANGE_PASSWORD, {
        password,
        newPassword
    })
}

export async function loadDeviceByAssetNo(assetNo) {
    return await get(Api.LOAD_DEVICE_BY_ASSET_NO + assetNo)
}

export async function listAllUser() {
    return await get(Api.LIST_ALL_USER);
}
export async function listOtherUser() {
    return await get(Api.LIST_OTHER_USER);
}

export async function borrowDevice(assetNo, relatedUserId) {
    return await post(Api.BORROW_DEVICE, {
        assetNo,
        relatedUserId
    })
}

export async function listMyBorrowHis(
    pageNum,
    pageSize,
    data
) {
    return await post(
        Api.MY_BORROW_HIS + "?pageNum=" + pageNum + '&pageSize=' + pageSize,
        data,
    );
}

export async function listAvailableDevice(
    pageNum,
    pageSize,
    data
) {
    return await post(
        Api.AVAILABLE_DEVICE + "?pageNum=" + pageNum + '&pageSize=' + pageSize,
        data,
    );
}

export async function listDeviceType() {
    return await get(Api.LIST_DEVICE_TYPE);
}

export async function applyReturn(hisId) {
    return await post(Api.APPLY_RETURN + hisId);
}

export async function confirmReturn(assetNo) {
    return await put(Api.CONFIRM_RETURN + assetNo);
}

export async function applyTransfer(hisId, targetBorrowerId, targetRelatedUserId, reason) {
    return await post(Api.APPLY_TRANSFER, {
        hisId,
        targetBorrowerId,
        targetRelatedUserId,
        reason
    });
}
export async function listMyApproveHis(
    pageNum,
    pageSize,
    data
) {
    return await post(
        Api.MY_APPROVE_HIS + "?pageNum=" + pageNum + '&pageSize=' + pageSize,
        data,
    );
}

export async function approve(approveHisId, approve, approveDesc) {
    return await put(Api.APPROVE, {
        approveHisId,
        approve,
        approveDesc
    })
}